import { z } from 'zod';

import { PerformanceReviewQuarter, PerformanceReviewStage, PerformanceReviewVersion } from '@/common/graphql';

export const PerformanceReviewDetail = z.object({
  id: z.string(),
  year: z.number(),
  quarter: z.nativeEnum(PerformanceReviewQuarter),
  version: z.nativeEnum(PerformanceReviewVersion),
  isCurrent: z.boolean(),
  stage: z.nativeEnum(PerformanceReviewStage),
  effectivePeriod: z.object({
    start: z.string(),
    end: z.string(),
  }),
});

export type PerformanceReviewDetailType = z.infer<typeof PerformanceReviewDetail>;

export const getPerformanceReviewStageLabel = (
  stage: PerformanceReviewStage,
  version: PerformanceReviewVersion,
): string => {
  switch (stage) {
    case PerformanceReviewStage.TargetSetting:
      switch (version) {
        case PerformanceReviewVersion.Version_1:
          return 'Target Setting';
        case PerformanceReviewVersion.Version_2:
          return 'Mission Setting';
      }
      break;
    case PerformanceReviewStage.TargetEvaluation:
      switch (version) {
        case PerformanceReviewVersion.Version_1:
          return 'Target Evaluation';
        case PerformanceReviewVersion.Version_2:
          return 'Performance Evaluation';
      }
      break;
    case PerformanceReviewStage.Closed:
      return 'Closed for Edits';
  }
};

export const comparePerformanceReviewStage = (
  one: PerformanceReviewStage,
  another: PerformanceReviewStage,
): -1 | 0 | 1 => {
  switch (one) {
    case PerformanceReviewStage.TargetSetting:
      if (another === PerformanceReviewStage.TargetSetting) {
        return 0;
      }

      return 1;
    case PerformanceReviewStage.TargetEvaluation:
      if (another === PerformanceReviewStage.TargetSetting) {
        return -1;
      } else if (another === PerformanceReviewStage.Closed) {
        return 1;
      }

      return 0;
    case PerformanceReviewStage.Closed:
      if (another === PerformanceReviewStage.Closed) {
        return 0;
      }

      return -1;
  }
};
